(function () {
	'use strict';
	angular.module('app.core')
		.service('metricRoundingService', metricRoundingService);

	function metricRoundingService() {
		return {
			getDecimals: getDecimals
		};

		function getDecimals(metricResult) {
			var decimals = numberOfDecimals(metricResult.value, undefined, true);
			if (metricResult.valueFunction === 'valueA/valueB*100') {
				var decimalsInValueAValueB = Math.max(
					numberOfDecimals(metricResult.valueA, undefined, true),
					numberOfDecimals(metricResult.valueB, undefined, true)
				);
				// If the components are round numbers, but the result isn't round, allow 2 decimal points
				if (decimalsInValueAValueB === 0 && decimals > 0) {
					decimals = 2;
				} else {
					decimals = decimalsInValueAValueB;
				}
			}
			return decimals;
		}
	}
})();